const colors = ["blue", "red", "orange", "green", "brown", "yellow", "purple", "light-gray", "gray"]
export type GridDiagramCellColor = (typeof colors)[number]

export const isGridDiagramCellColor = (x: any): x is GridDiagramCellColor =>  colors.includes(x)
